import tickImage from '../../../assets/tick.png';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSuccessScreenDescription, selectSuccessScreenTitle } from '../../../../../selectors/successScreens';
import { PaymentResult } from '../../PaymentResult';

interface IProps {
  onClose(): void;
}

export const PackageWithRedirect = (props: IProps) => {
  const { onClose } = props;

  const title = useSelector(selectSuccessScreenTitle);
  const description = useSelector(selectSuccessScreenDescription);

  return (
    <PaymentResult
      image={tickImage}
      title={title}
      description={description}
      newOfferButton
      testId="success-buy-package-with-redirect-modal"
      buttonTitle="Закрыть"
      onClick={onClose}
    />
  );
};
